import classnames from 'classnames/bind'
import { useRef } from 'react'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'

import Slider from '@unlikelystudio/react-slider'

import InlineCta, { InlineCtaProps } from '~/components/UI/InlineCta'
import ProductCard, { ProductCardProps } from '~/components/UI/ProductCard'
import { CARD_PRODUCT_LAYOUT } from '~/components/UI/ProductCard/types'

import { useStyle } from '~/providers/StyleProvider'

import { EditoSliceProps } from '~/data/slices-data'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type ProductsRowTitleLinkProps = EditoSliceProps & {
  className?: string
  title?: string
  link?: InlineCtaProps
  items?: ProductCardProps[]
}

function ProductsRowTitleLink({
  className,
  title,
  link,
  items,
}: ProductsRowTitleLinkProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const componentRef = useRef()
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title30_40SangBleu,
  })

  return (
    <div className={cx(css.ProductsRowTitleLink, className)} ref={componentRef}>
      <div className={cx(css.container, gridStyle)}>
        {(title || link) && (
          <div className={cx(css.titleRow)}>
            {title && <h3 className={cx(css.title, titleStyle)}>{title}</h3>}
            {link && (
              <InlineCta
                className={cx(css.link)}
                textPreset={GlobalTextPreset.Cta12Grotesk}
                {...link}
              />
            )}
          </div>
        )}
        {items?.length > 0 && (
          <Slider
            className={cx(css.productsRow)}
            customSliderRef={componentRef}>
            {items?.map((item, key) => (
              <ProductCard
                layout={CARD_PRODUCT_LAYOUT.BIG_GRID}
                key={`products_row_item_${key}`}
                className={cx(css.item)}
                {...item}
              />
            ))}
          </Slider>
        )}
      </div>
    </div>
  )
}

ProductsRowTitleLink.defaultProps = {}

export default ProductsRowTitleLink
